import { formatMultipleSortingForEndpoint } from '@app/components/data-table/lib/parsers';
import Page from '@app/components/layout/page/page';
import { useDataTableQueryState } from '@app/hooks/use-data-table-query-state';
import { useGetPurchasedPackagingList } from '@shared/api/hooks/purchased-goods/packaging';
import { PurchasedGoodsPackagingListParams } from '@shared/api/types';
import { parseAsString, useQueryState } from 'nuqs';
import PurchasedPackagingTable from '../components/purchased-packaging-table';
import { packagingFilters } from '../filters';

export default function PurchasedPackagingListPage() {
  const [search] = useQueryState('packagingName', parseAsString);
  const { page, perPage, sort, ...filterStates } = useDataTableQueryState({
    filters: Object.values(packagingFilters).map(({ column }) => column),
  });

  const params: PurchasedGoodsPackagingListParams = {
    page,
    page_size: perPage,
    search: search || undefined,
    sort: formatMultipleSortingForEndpoint(sort! || []),
  };
  // Build the API params from the table filters
  Object.values(packagingFilters).forEach(({ apiKey, column }) => {
    params[apiKey] = filterStates[column];
  });

  const { data, status, isLoading, isFetchedAfterMount, isPreviousData } =
    useGetPurchasedPackagingList(params);

  return (
    <Page name="Packaging" page="subpage">
      <PurchasedPackagingTable
        data={data}
        status={status}
        pageSize={perPage}
        isLoading={(!isFetchedAfterMount && isPreviousData) || isLoading}
        isPreviousData={isPreviousData}
      />
    </Page>
  );
}
